import base62 from 'base62';
import { TIME_DIVISOR, TIMESTAMP_LENGTH } from './uidConstants';

export const parseTimestamp = (timeStamp) => base62.decode(timeStamp) * TIME_DIVISOR;

export const getTimestamp = (id) => parseTimestamp(id.slice(0, TIMESTAMP_LENGTH));

export const createTimestamp = (time, divisor = TIME_DIVISOR) => base62.encode(Math.floor(time / divisor));
